import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter,
} from "@/components/ui/dialog";

/**
 * Modal that asks for the suspension reason when a row is unmarked as
 * "executed". Pure presentational — parent owns the `state` object and
 * commits via `onSubmit` / closes via `onClose`.
 */
export default function SuspensionDialog({ state, onChange, onClose, onSubmit }) {
  const open = !!state;
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Suspender cirurgia</DialogTitle>
        </DialogHeader>
        {state && (
          <div className="space-y-4">
            <div className="text-sm text-slate-600">
              Paciente: <strong>{state.patient_name}</strong>
            </div>
            <div className="space-y-1.5">
              <Label>Motivo da suspensão *</Label>
              <select
                className="w-full border border-slate-300 rounded-md px-3 h-11 md:h-9 text-base md:text-sm bg-white"
                value={state.reason}
                onChange={(e) => onChange({ ...state, reason: e.target.value })}
                data-testid="select-suspension-reason"
              >
                <option value="condicoes_clinicas">Condições clínicas</option>
                <option value="falta_uti">Falta de UTI</option>
                <option value="paciente_nao_compareceu">Paciente não compareceu</option>
                <option value="outros">Outros</option>
              </select>
            </div>
            <div className="space-y-1.5">
              <Label>
                Observação{state.reason === "outros" ? " *" : " (opcional)"}
              </Label>
              <Textarea
                rows={3}
                value={state.notes}
                onChange={(e) => onChange({ ...state, notes: e.target.value })}
                placeholder={state.reason === "outros" ? "Descreva o motivo" : "Detalhes adicionais (opcional)"}
                data-testid="input-suspension-notes"
              />
            </div>
          </div>
        )}
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Cancelar</Button>
          <Button className="bg-red-600 hover:bg-red-700" onClick={onSubmit} data-testid="btn-submit-suspension">
            Confirmar suspensão
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
